import { Button, Flex } from 'zui/Antd';

const InventoryControlActions = ({
	record,
	selectedInventoryUIDs,
	setSelectedInventoryUIDs,
	setSelectedDevice,
	setVisibleEditLocation,
	setOpenAssignModal,
	setOpenUnassignModal
}) => {
	const handleAssign = (e) => {
		e.stopPropagation();

		setSelectedInventoryUIDs((prev) => {
			const exists = prev.some((item) => item.inventoryUID === record.ID);
			if (exists) return prev;

			return [
				...prev,
				{
					inventoryUID: record.ID,
					deviceID: record.organisation?.assetID || null,
					orgID: record.organisation?.orgID || null,
					name: record.name || record.alias || 'Unnamed Device'
				}
			];
		});

		setOpenAssignModal(true);
	};

	const handleModifyLocation = (e) => {
		e.stopPropagation();

		setSelectedDevice({
			inventoryUID: record.ID,
			deviceID: record.organisation?.assetID || null,
			orgID: record.organisation?.orgID || null,
			name: record.name || record.alias || 'Unnamed Device'
		});

		setVisibleEditLocation(true);
	};

	const handleUnassign = (e) => {
		e.stopPropagation();

		if (selectedInventoryUIDs.length === 0) {
			setSelectedInventoryUIDs([
				{
					inventoryUID: record.ID,
					deviceID: record.organisation?.assetID || null,
					orgID: record.organisation?.orgID || null,
					name: record.name || record.alias || 'Unnamed Device'
				}
			]);
		}

		setOpenUnassignModal(true);
	};

	if (!record.organisation?.orgID) {
		return (
			<Button size='small' type='primary' onClick={handleAssign}>
				Assign
			</Button>
		);
	}

	return (
		<Flex gap={8} justify='space-between'>
			<Button size='small' type='primary' onClick={handleModifyLocation}>
				Modify Location
			</Button>
			<Button size='small' type='primary' onClick={handleUnassign}>
				Unassign
			</Button>
		</Flex>
	);
};

export default InventoryControlActions;
